// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import { UseQueryResult } from "@tanstack/react-query";
import {
  accountLookup,
  auth0,
  avelaAi,
  branding,
  contacts,
  externalCapacity,
  identityAi,
  login,
  match,
  mfa,
  orgConfig,
  payments,
  translationOptions,
} from "../requests/services.gen";
import {
  AccountLookupData,
  Auth0Data,
  AvelaAiData,
  BrandingData,
  ContactsData,
  ExternalCapacityData,
  IdentityAiData,
  LoginData,
  MatchData,
  MfaData,
  OrgConfigData,
  PaymentsData,
  TranslationOptionsData,
} from "../requests/types.gen";
export type OrgConfigDefaultResponse = Awaited<
  ReturnType<typeof orgConfig>
>["data"];
export type OrgConfigQueryResult<
  TData = OrgConfigDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useOrgConfigKey = "OrgConfig";
export const UseOrgConfigKeyFn = (
  clientOptions: Options<OrgConfigData, true>,
  queryKey?: Array<unknown>
) => [useOrgConfigKey, ...(queryKey ?? [clientOptions])];
export type BrandingDefaultResponse = Awaited<
  ReturnType<typeof branding>
>["data"];
export type BrandingQueryResult<
  TData = BrandingDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useBrandingKey = "Branding";
export const UseBrandingKeyFn = (
  clientOptions: Options<BrandingData, true>,
  queryKey?: Array<unknown>
) => [useBrandingKey, ...(queryKey ?? [clientOptions])];
export type ContactsDefaultResponse = Awaited<
  ReturnType<typeof contacts>
>["data"];
export type ContactsQueryResult<
  TData = ContactsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useContactsKey = "Contacts";
export const UseContactsKeyFn = (
  clientOptions: Options<ContactsData, true>,
  queryKey?: Array<unknown>
) => [useContactsKey, ...(queryKey ?? [clientOptions])];
export type Auth0DefaultResponse = Awaited<ReturnType<typeof auth0>>["data"];
export type Auth0QueryResult<
  TData = Auth0DefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useAuth0Key = "Auth0";
export const UseAuth0KeyFn = (
  clientOptions: Options<Auth0Data, true>,
  queryKey?: Array<unknown>
) => [useAuth0Key, ...(queryKey ?? [clientOptions])];
export type LoginDefaultResponse = Awaited<ReturnType<typeof login>>["data"];
export type LoginQueryResult<
  TData = LoginDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useLoginKey = "Login";
export const UseLoginKeyFn = (
  clientOptions: Options<LoginData, true>,
  queryKey?: Array<unknown>
) => [useLoginKey, ...(queryKey ?? [clientOptions])];
export type TranslationOptionsDefaultResponse = Awaited<
  ReturnType<typeof translationOptions>
>["data"];
export type TranslationOptionsQueryResult<
  TData = TranslationOptionsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useTranslationOptionsKey = "TranslationOptions";
export const UseTranslationOptionsKeyFn = (
  clientOptions: Options<TranslationOptionsData, true>,
  queryKey?: Array<unknown>
) => [useTranslationOptionsKey, ...(queryKey ?? [clientOptions])];
export type AccountLookupDefaultResponse = Awaited<
  ReturnType<typeof accountLookup>
>["data"];
export type AccountLookupQueryResult<
  TData = AccountLookupDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useAccountLookupKey = "AccountLookup";
export const UseAccountLookupKeyFn = (
  clientOptions: Options<AccountLookupData, true>,
  queryKey?: Array<unknown>
) => [useAccountLookupKey, ...(queryKey ?? [clientOptions])];
export type MatchDefaultResponse = Awaited<ReturnType<typeof match>>["data"];
export type MatchQueryResult<
  TData = MatchDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useMatchKey = "Match";
export const UseMatchKeyFn = (
  clientOptions: Options<MatchData, true>,
  queryKey?: Array<unknown>
) => [useMatchKey, ...(queryKey ?? [clientOptions])];
export type AvelaAiDefaultResponse = Awaited<
  ReturnType<typeof avelaAi>
>["data"];
export type AvelaAiQueryResult<
  TData = AvelaAiDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useAvelaAiKey = "AvelaAi";
export const UseAvelaAiKeyFn = (
  clientOptions: Options<AvelaAiData, true>,
  queryKey?: Array<unknown>
) => [useAvelaAiKey, ...(queryKey ?? [clientOptions])];
export type IdentityAiDefaultResponse = Awaited<
  ReturnType<typeof identityAi>
>["data"];
export type IdentityAiQueryResult<
  TData = IdentityAiDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useIdentityAiKey = "IdentityAi";
export const UseIdentityAiKeyFn = (
  clientOptions: Options<IdentityAiData, true>,
  queryKey?: Array<unknown>
) => [useIdentityAiKey, ...(queryKey ?? [clientOptions])];
export type PaymentsDefaultResponse = Awaited<
  ReturnType<typeof payments>
>["data"];
export type PaymentsQueryResult<
  TData = PaymentsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const usePaymentsKey = "Payments";
export const UsePaymentsKeyFn = (
  clientOptions: Options<PaymentsData, true>,
  queryKey?: Array<unknown>
) => [usePaymentsKey, ...(queryKey ?? [clientOptions])];
export type ExternalCapacityDefaultResponse = Awaited<
  ReturnType<typeof externalCapacity>
>["data"];
export type ExternalCapacityQueryResult<
  TData = ExternalCapacityDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExternalCapacityKey = "ExternalCapacity";
export const UseExternalCapacityKeyFn = (
  clientOptions: Options<ExternalCapacityData, true>,
  queryKey?: Array<unknown>
) => [useExternalCapacityKey, ...(queryKey ?? [clientOptions])];
export type MfaDefaultResponse = Awaited<ReturnType<typeof mfa>>["data"];
export type MfaQueryResult<
  TData = MfaDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useMfaKey = "Mfa";
export const UseMfaKeyFn = (
  clientOptions: Options<MfaData, true>,
  queryKey?: Array<unknown>
) => [useMfaKey, ...(queryKey ?? [clientOptions])];
